import React from "react";

// Hooks
import { useHistory } from "react-router-dom";

// Components
import Button from "../../../overrides/venia-ui/components/Button";

// Styles
import defaultClasses from "./myAccountOffCanvas.module.scss";
import { mergeClasses } from "@magento/venia-ui/lib/classify";

//Utils
import { useIntl } from "react-intl";
import { useUserContext } from "@magento/peregrine/lib/context/user";
import { MoneyBox, SeedsBox, getBackgroundMobile } from "../seedsUtils";
import { bgImage } from "@Src_main/utils/generalUtils";
const MyAccountOffCanvas = () => {
  const history = useHistory();
  const {
    formatMessage
  } = useIntl();
  const [{
    currentUser
  }] = useUserContext();
  const totalPoints = currentUser && currentUser.lsAccount && currentUser.lsAccount.scheme && parseInt(currentUser.lsAccount.scheme.point_balance);
  const classes = mergeClasses(defaultClasses);
  const button = /*#__PURE__*/React.createElement(Button, {
    color: "white",
    fullScreen: false,
    onClick: () => {
      UIkit.offcanvas("#offcanvas-my-account").hide();
      history.push(formatMessage({
        id: "url.key.myaccount"
      }));
    }
  }, formatMessage({
    id: "loyalty.go.home"
  }));
  const seeds = /*#__PURE__*/React.createElement(SeedsBox, {
    totalPoints: totalPoints,
    classes: classes
  }, button);
  const money = /*#__PURE__*/React.createElement(MoneyBox, {
    totalPoints: totalPoints,
    classes: classes
  }, button);
  const bg = {
    "--background-mobile": bgImage(getBackgroundMobile(totalPoints)),
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    overscrollBehavior: "none"
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "offcanvas-my-account uk-flex uk-flex-center ".concat(classes.myAccountOffCanvas),
    style: bg
  }, totalPoints < 500 ? seeds : money);
};
export default MyAccountOffCanvas;